import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { CodeStyle } from 'utils/code';

class FrontendSCSS extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>SCSS</title>
                    <meta name="description" content="SCSS" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Frontend"  breadcrumb_2="SCSS" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">SCSS</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                            <h4>Styling The World</h4>
                            <p className="text-sm">
                                As of this writing all Architeck systems start out on top of reactstrap and Creative Tim's Argon Dashboard. <br />
                                
                                Our scss structure is as follows, under the folder /assets/scss you will two variable files and and index file.<br />
                                The index file is used to require all other scss files we are using. In this file, you may also change the websites theme from dark to light here by following the inline documentation to do so.
                            </p>
                            <p className="text-sm">
                               NOTE** If you are adding scss for a custom component and not something global or universal create a new scss file for it under /assets/scss/custom/components and then require it in index.scss.<br />
                               If you are updating global styles go ahead and do so the main set of files found in /assets/scss/custom
                            </p>

                    
                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default FrontendSCSS